/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useState } from 'react';
import { icons } from '../../../../configs/Icons';
import { useAuth } from '../../../Contexts/AuthProvider';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ImageUploadingIcon } from '../../../utils/SVGIcon';
import { handleUpdateProfilePhotoOpe } from '../UserProfileOperation';
import UserRoleIconPicker from './UserRoleIconPicker';

function UserInfoCard({ name, icon, role, isLoading }) {
    return (
        <div className="user-card-v1 w-full flex flex-row items-center gap-x-3 sm:gap-x-5 md:gap-x-7">
            <div className="overflow-hidden h-[70px] md:h-[100px] w-[70px] md:w-[100px] rounded-full border border-secondary-100 relative">
                {isLoading && (
                    <div className="absolute w-full h-full bg-secondary/20 text-secondary z-50">
                        <ImageUploadingIcon />
                    </div>
                )}
                <img
                    src={icon || icons.defaultAvatar}
                    alt={name || 'Avatar'}
                    className="w-full h-full inline-block object-cover"
                />
            </div>
            <div className="flex flex-col gap-0 md:gap-2 items-start justify-center text-left">
                <h1 className="text-primary text-xl md:text-[35px] font-medium overflow-hidden text-ellipsis">
                    {name || '-------------'}
                </h1>
                <div className="text-primary-700 text-base md:text-[25px] font-normal overflow-hidden text-ellipsis capitalize flex items-center gap-x-1 leading-normal">
                    {role || '-------------'}
                    <div className="w-7 md:w-9">
                        <UserRoleIconPicker role={role} />
                    </div>
                </div>
            </div>
        </div>
    );
}

function UserInfoRow() {
    const { authInfo, authStateUpdated } = useAuth();
    const { setMessage } = useTemplate();
    const { photoUrl, firstName, lastName, role } = authInfo?.data || {};
    const [isLoading, setIsLoading] = useState(false);
    // Handle upload image
    const handleUpload = (e) => {
        if (!e.target.files[0]) return;
        const formData = new FormData();
        formData.append('profileImage', e.target.files[0]);
        setIsLoading(true);
        handleUpdateProfilePhotoOpe(formData)
            .then((res) => {
                setMessage({ type: 'success', text: res?.title });
                authStateUpdated();
                setTimeout(() => {
                    setIsLoading(false);
                }, 2000);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.toString(0) });
                setIsLoading(false);
            });
    };

    return (
        <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-3 sm:gap-0 border-b border-primary-100 pb-5 sm:pb-6 md:pb-7.5 mb-5 sm:mb-6 md:mb-7.5">
            <div>
                <UserInfoCard
                    isLoading={isLoading}
                    icon={photoUrl}
                    name={`${firstName} ${lastName}`}
                    role={role}
                />
            </div>

            <form encType="multipart/form-data">
                <label className="inline-block bg-secondary text-white font-medium text-xs sm:text-sm md:text-base px-3 md:px-5 py-2 md:py-3 rounded-10 cursor-pointer">
                    <span className="inline-block w-full text-center">Change Image</span>
                    <input
                        type="file"
                        onChange={handleUpload}
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                    />
                </label>
            </form>
        </div>
    );
}

export default UserInfoRow;
